import React from 'react';

interface IOrgSectionProps {
  settings: any;
}

const OrgSection: React.FunctionComponent<IOrgSectionProps> = ({
  settings,
}) => (
  <div className="organization-section">
    <div className="section-container">
      <div className="organization-section-label">
        {settings?.organizationLabel}
      </div>
      <div className="organization-list">
        {Array.from('x'.repeat(30)).map((itm, idx) => (
          <div key={idx}>
            <img
              src={
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                require(`../../../assets/sponsor-logo/${idx + 1}.png`).default
              }
              alt=""
            />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default OrgSection;
